import { Check } from "lucide-react";
import { Reveal, Chapter, scrollToId } from "./shared";

const FEATURES = [
  "Custom lead capture website (up to 6 pages) built around one goal: contact",
  "We guide you through Google Business Profile setup, verification, and ongoing optimization",
  "Ongoing local SEO to keep your rankings climbing on Search and Maps",
  "Contact form delivered straight to your inbox",
  "Monthly ranking and traffic report",
  "Secure website hosting, content updates & priority support included",
];

const Plan = () => (
  <section id="pricing" className="py-16 sm:py-24 lg:py-28 bg-white border-b border-[#e7e1d6]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto text-center flex flex-col items-center gap-4 mb-14">
        <Chapter num="01" label="The Plan" />
        <Reveal delay={0.1}>
          <h2 className="text-3xl sm:text-4xl font-serif font-normal tracking-tight text-[#16324a]">
            One Plan. Everything Working Together.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="text-base sm:text-lg text-[#334e68]">
            Your website, your Google Business Profile, and your search rankings — managed as
            one plan instead of three separate vendors.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="max-w-lg mx-auto">
        <div
          data-testid="plan-card"
          className="relative bg-[#faf7f2] border border-[#e7e1d6] rounded-2xl p-7 sm:p-10 shadow-xl overflow-hidden"
        >
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#c99a43] via-[#e8c78f] to-[#c99a43]" />
          <h3 className="font-serif text-2xl sm:text-3xl font-medium text-[#16324a]">The Growth Plan</h3>
          <p className="text-sm text-[#627d98] mt-1">Website + Local SEO + Google Business Profile</p>

          <div className="mt-6 flex items-end gap-3 flex-wrap">
            <span data-testid="plan-price" className="font-serif text-5xl sm:text-6xl text-[#16324a] leading-none">$399</span>
            <span className="text-sm text-[#627d98] pb-1.5">
              one-time build
              <br />
              + <strong className="text-[#16324a]">$75/mo</strong> hosting &amp; updates
            </span>
          </div>

          <p className="mt-5 text-[15px] text-[#334e68] leading-relaxed">
            A fast, mobile-first website built to turn visitors into calls, backed by an
            optimized Google Business Profile and ongoing local SEO that keeps your rankings
            climbing.
          </p>

          <ul className="mt-6 flex flex-col gap-3.5">
            {FEATURES.map((f, i) => (
              <li key={i} className="flex items-start gap-3 text-[15px] text-[#334e68]">
                <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full bg-[#e8c78f]/50 text-[#a37d3f] flex items-center justify-center">
                  <Check size={13} strokeWidth={3} />
                </span>
                {f}
              </li>
            ))}
          </ul>

          <button
            data-testid="plan-cta-button"
            onClick={() => scrollToId("contact")}
            className="mt-8 w-full bg-[#16324a] text-[#faf7f2] font-semibold px-6 py-4 rounded-full hover:bg-[#c99a43] hover:text-[#16324a] transition-colors duration-300"
          >
            Get Started
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Plan;
